import type { FC, SVGProps } from 'react';

export const InboxDropZoneIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="48"
    fill="none"
    height="48"
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fill="#1750AC"
      d="M41.4939 20.9109L41.4845 20.8734L36.2252 7.50937C35.9908 6.75469 35.2923 6.23438 34.5002 6.23438H13.1814C12.3845 6.23438 11.6767 6.76406 11.4517 7.52813L6.53453 20.7562L6.52047 20.7891L6.51109 20.8266C6.45016 21.0562 6.43141 21.2906 6.46422 21.5203C6.45953 21.5953 6.45484 21.6703 6.45484 21.7453V38.8969C6.45608 39.6524 6.75675 40.3765 7.29096 40.9108C7.82517 41.445 8.54936 41.7456 9.30484 41.7469H38.7048C40.2752 41.7469 41.5548 40.4672 41.5595 38.8969V21.7453C41.5595 21.6844 41.5595 21.6234 41.5548 21.5719C41.5736 21.3422 41.5548 21.1219 41.4939 20.9109ZM27.6283 18.8953L27.6142 19.6312C27.5767 21.7359 26.1236 23.1516 24.0002 23.1516C22.9642 23.1516 22.0736 22.8187 21.4314 22.1859C20.7892 21.5531 20.4377 20.6719 20.4189 19.6312L20.4048 18.8953H10.758L14.4845 9.83437H33.197L37.0267 18.8953H27.6283ZM10.0502 22.4953H17.4236C18.5627 25.1719 20.9861 26.7516 24.0048 26.7516C25.5845 26.7516 27.0517 26.3109 28.2377 25.4766C29.2783 24.7453 30.0892 23.7234 30.6142 22.4953H37.9502V38.1469H10.0502V22.4953Z"
    />
  </svg>
);
